import TextField from '@mui/material/TextField'
import styles from './styles.module.css'
import {
  ChangeEvent,
  Dispatch,
  MouseEventHandler,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { ISchedulerStateProps } from '../../container-modal/initialData'
import { SUGGESTIONS_ALERT_MESSAGES } from '../TireSizeQuantity'

export interface IVehicleDetailsProps {
  schedulerState: ISchedulerStateProps
  setSchedulerState: Dispatch<SetStateAction<ISchedulerStateProps>>
  setPsiTorqueModalOpen: MouseEventHandler
  alertProps: any
}

function VehicleDetails(props: IVehicleDetailsProps) {
  const {
    schedulerState,
    setSchedulerState,
    setPsiTorqueModalOpen,
    alertProps,
  } = props
  const {
    tiresCombination: { frontTire, rearTire },
    customerInformation,
  } = schedulerState
  const [buttonColor, setButtonColor] = useState(alertProps.color)

  function handlePsiChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target
    const tireKey = name === 'frontPsi' ? 'frontTire' : 'rearTire'

    setSchedulerState((prevState: ISchedulerStateProps) => {
      const newValue = value === '' ? null : Number(value)
      return {
        ...prevState,
        tiresCombination: {
          ...prevState.tiresCombination,
          [tireKey]: {
            ...prevState.tiresCombination[tireKey],
            psi: newValue,
          },
        },
      }
    })
  }

  const [isHovered, setIsHovered] = useState(false)
  function handleMouseEnter() {
    setIsHovered(true)
  }

  function handleMouseLeave() {
    setIsHovered(false)
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target
    setSchedulerState((prevSchedulerState: ISchedulerStateProps) => {
      if (name === 'mileage') {
        return {
          ...prevSchedulerState,
          customerInformation: {
            ...prevSchedulerState.customerInformation,
            [name]: value === '' ? null : Number(value),
          },
        }
      }

      // these tire details we will apply to both front and rear tires
      return {
        ...prevSchedulerState,
        tiresCombination: {
          ...prevSchedulerState.tiresCombination,
          frontTire: {
            ...prevSchedulerState.tiresCombination.frontTire,
            [name]: value,
          },
          rearTire: {
            ...prevSchedulerState.tiresCombination.rearTire,
            [name]: value,
          },
        },
      }
    })
  }

  useEffect(() => {
    setButtonColor(
      isHovered ? alertProps.hoverColor : alertProps.backgroundColor,
    )
  }, [isHovered, alertProps.hoverColor, alertProps.backgroundColor])

  return (
    <div className={styles.vehicleDetailsContainer}>
      <div className={`${styles.detailsTitle} font--bold`}>Details</div>
      <div className={styles.inputsContainer}>
        <button
          onClick={setPsiTorqueModalOpen}
          className={styles.psiTorqueButton}
          disabled={
            alertProps.message === SUGGESTIONS_ALERT_MESSAGES.default ||
            alertProps.message ===
              SUGGESTIONS_ALERT_MESSAGES.enterInformation ||
            alertProps.message === SUGGESTIONS_ALERT_MESSAGES.noMatch
          }
          style={{ backgroundColor: buttonColor }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <span className={styles.psiTorqueButtonText}>
            {alertProps.message}
          </span>
        </button>
        <div className={styles.vehicleDetailsButtonsContainer}>
          <div className={styles.psiTorqueContainer}>
            <TextField
              label='Front Psi'
              name='frontPsi'
              type='number'
              onChange={handlePsiChange}
              value={frontTire?.psi ?? ''}
              InputLabelProps={{ shrink: frontTire?.psi ? true : false }} // hacky way to shrink label when value is auto-filled
            />
            <TextField
              label='Rear Psi'
              name='rearPsi'
              type='number'
              onChange={handlePsiChange}
              value={rearTire?.psi ?? ''}
              InputLabelProps={{ shrink: rearTire?.psi ? true : false }} // hacky way to shrink label when value is auto-filled
            />
            <TextField
              label='Torque'
              name='torque'
              type='number'
              value={frontTire?.torque ?? ''}
              onChange={handleChange}
              InputLabelProps={{ shrink: frontTire?.torque ? true : false }} // hacky way to shrink label when value is auto-filled
            />
          </div>
          <TextField
            label='Tire Make'
            name='manufacturer'
            type='string'
            value={frontTire?.manufacturer || rearTire?.manufacturer || ''}
            fullWidth
            onChange={handleChange}
          />
          <TextField
            label='Tire Model'
            name='model'
            type='string'
            value={frontTire?.model || rearTire?.model || ''}
            fullWidth
            onChange={handleChange}
          />
          <TextField
            label='Vehicle Mileage'
            name='mileage'
            type='number'
            value={customerInformation.mileage || ''}
            fullWidth
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  )
}

export default VehicleDetails
